import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../../../../img/Axxess_Intelligence_logo_2.svg'


const _hoisted_1 = { class: "w-25 ps-2 pt-2 bg-white d-flex flex-column position-relative" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-1 pe-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold m-0" }, "Find Nearby Employees", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ai-line" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "row pe-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-4 pe-0 ps-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-control border-0 text-dark my-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Search")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "form-control border-0 text-dark my-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Distance")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "form-control border-0 text-dark my-2" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Credentials")
  ])
], -1 /* HOISTED */)
const _hoisted_7 = { class: "col-8 ps-0" }
const _hoisted_8 = { class: "my-2" }
const _hoisted_9 = { class: "my-2" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<option value=\"5\">5 miles</option><option value=\"10\">10 miles</option><option value=\"15\">15 miles</option><option value=\"20\">20 miles</option><option value=\"25\">25 miles</option>", 5)
const _hoisted_15 = [
  _hoisted_10
]
const _hoisted_16 = { class: "my-2 credentials-filter" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = { class: "fw-bold" }
const _hoisted_20 = {
  key: 0,
  class: "btn text-success p-0 fw-semibold"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "text-muted" }
const _hoisted_23 = { class: "my-1" }
const _hoisted_24 = { class: "d-flex align-items-center mb-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "me-2 pill green-pill" }, "Active", -1 /* HOISTED */)
const _hoisted_26 = { class: "text-muted fw-bold" }
const _hoisted_27 = {
  class: "text-center py-2",
  ref: "trigger"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw fa-2x" }, null, -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "Loading...", -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "text-center py-2"
}
const _hoisted_32 = {
  key: 1,
  class: "nearby-emp-list pe-1"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "pe-2",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("button", { class: "ai-premium-btn mx-2 mt-2 mb-1" }, "Premium")
], -1 /* HOISTED */)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "ai-line" }, null, -1 /* HOISTED */)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex-grow-1",
  id: "NearbyEmp__VisitMap"
}, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiSelectFilter = _resolveComponent("MultiSelectFilter")!
  const _component_ProductPill = _resolveComponent("ProductPill")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "btn text-primary fw-bold p-0 me-3",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearNearbyEmpFilters()))
          }, "Clear"),
          _createElementVNode("button", {
            class: "btn text-primary fw-bold p-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeNearbyEmpPanel()))
          }, "Done")
        ])
      ]),
      _hoisted_4,
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              class: "form-control",
              placeholder: "Search by Name",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nearbyEmpSearchTerm) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.nearbyEmpSearchTerm]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.nearbyEmpDistance) = $event))
            }, _hoisted_15, 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.nearbyEmpDistance]
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_MultiSelectFilter, {
              "on-fetch": _ctx.userCredentialsFetch,
              selectedItems: _ctx.selectedCredentials,
              onSelectedItemsUpdated: _ctx.selectedItemsUpdated,
              name: "User Credentials",
              ref: "credentialsRef"
            }, null, 8 /* PROPS */, ["on-fetch", "selectedItems", "onSelectedItemsUpdated"])
          ])
        ])
      ]),
      _createElementVNode("section", {
        class: _normalizeClass(`nearby-emp-list pe-1 ${_ctx.userOs == 'Windows' ? 'custom-scrollbar' : ''}`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearbyEmpPanelList, (emp) => {
          return (_openBlock(), _createElementBlock("div", {
            key: emp.UserDetails.id,
            class: _normalizeClass(`nearby-emp-card mb-2 ${_ctx.selectedNearbyEmp.id === emp.UserDetails.id ? 'selected' : ''}`),
            onClick: ($event: any) => (_ctx.highlightEmpPin(emp.UserDetails, emp.UserDetails.id))
          }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(emp.UserDetails.firstName) + " " + _toDisplayString(emp.UserDetails.lastName) + " (" + _toDisplayString(emp.UserDetails.credentials ? emp.UserDetails.credentials.split(",")[0] : "None") + ") ", 1 /* TEXT */),
              (_ctx.selectedPatientVisit.UserId === emp.UserDetails.sourceUserId)
                ? (_openBlock(), _createElementBlock("button", _hoisted_20, " Assigned "))
                : (_ctx.isReassignAllowed)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn text-primary p-0 fw-semibold btn-assign",
                      onClick: ($event: any) => (_ctx.scheduledVisit(emp.UserDetails.sourceUserId))
                    }, " Assign ", 8 /* PROPS */, _hoisted_21))
                  : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("small", _hoisted_22, _toDisplayString(emp.UserDetails.distance) + " miles away", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_23, " D: " + _toDisplayString(emp.VisitFrequencyDay) + "v/" + _toDisplayString(emp.VisitHoursDay) + "hr W: " + _toDisplayString(emp.VisitFrequencyWeek) + "v/" + _toDisplayString(emp.VisitHoursWeek) + "hr ", 1 /* TEXT */),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_ProductPill, {
                class: "me-2",
                "product-id": _ctx.getApplicationId(emp.UserDetails.application)
              }, null, 8 /* PROPS */, ["product-id"]),
              _hoisted_25,
              _createElementVNode("small", _hoisted_26, _toDisplayString(emp.UserDetails.agencyName), 1 /* TEXT */)
            ])
          ], 10 /* CLASS, PROPS */, _hoisted_17))
        }), 128 /* KEYED_FRAGMENT */)),
        _withDirectives(_createElementVNode("div", _hoisted_27, _hoisted_30, 512 /* NEED_PATCH */), [
          [_vShow, _ctx.pageCount < _ctx.totalPageCount && _ctx.showLoading]
        ]),
        (_ctx.pageCount >= _ctx.totalPageCount && _ctx.nearbyEmpPanelList.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, " Showing " + _toDisplayString(_ctx.totalItemCount) + " Employees ", 1 /* TEXT */))
          : _createCommentVNode("v-if", true),
        (!_ctx.nearbyEmpPanelList.length && !_ctx.showLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, "No employees found"))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */),
      _hoisted_33,
      _hoisted_34
    ]),
    _hoisted_35
  ], 64 /* STABLE_FRAGMENT */))
}